"use client"

import React from 'react';
import EntryPoints from '../../framework/nav/EntryPoints';
import { NavItem } from '../../framework/nav/NavItem';
import Container from 'react-bootstrap/Container';
import Marquee from "react-fast-marquee";
import { ImgComparisonSlider } from '@img-comparison-slider/react';
import themeManager from '../../framework/common/theme/themeManager';

const bobaFett = 'https://i.postimg.cc/g2ntFBZv/BobaFett.jpg';
const lightsabers = 'https://i.postimg.cc/nhgRHY4N/Lightsabers-1.jpg';
// const lightsaber2 = 'https://i.postimg.cc/85KnzX1N/Lightsaber.jpg';
const aztek1 = 'https://i.postimg.cc/LspX253k/Aztek-Robot-1.jpg';
const aztek2 = 'https://i.postimg.cc/0N0NQvVT/Aztek-Robot-2.jpg';
const car1 = 'https://i.postimg.cc/cLydtfLm/Car-1-3.jpg';
const car2 = 'https://i.postimg.cc/j52CfCrP/Car-1-2-1.jpg';
const car3 = 'https://i.postimg.cc/L8ZTNDjF/Car2.png';
const columns = 'https://i.postimg.cc/mkCTsCPx/columns.png';
const japorSnippet = 'https://i.postimg.cc/65DyXcRZ/Japor-Snippet.png';
const cadBane = 'https://i.postimg.cc/FzYCdbRc/Cad-Bane.png';
const hallway = 'https://i.postimg.cc/08xD4P8r/Hallway-1-7.png';
const bridge1 = 'https://i.postimg.cc/6QGDGL8G/Bridge2-1.png';
const bridge2 = 'https://i.postimg.cc/nVwDccV8/Bridge4-2.png';


const blenderLogo = 'https://i.postimg.cc/4y2vWsw-j/blender.png';
const photoshopLogo = 'https://i.postimg.cc/bvfxC6HY/photoshop.png';
const premierProLogo = 'https://i.postimg.cc/zvQWnpGr/premier-Pro.png';
const onshapeLogo = 'https://i.postimg.cc/13q0KxFY/onshape.png';
const zbrushLogo = 'https://i.postimg.cc/ncQ9y4LX/zbrush.png';
const splineLogo = 'https://i.postimg.cc/fL20N5X9/spline.png';
const simscaleLogo = 'https://i.postimg.cc/fbsdjVDJ/simscale.png';
const prusaLogo = 'https://i.postimg.cc/WzzgFxj8/prusa.png';
const sketchupLogo = 'https://i.postimg.cc/jjh78RSv/sketchup.png';
const unrealLogo = 'https://i.postimg.cc/wxrs4f9K/unreal.png';
const ultimakerCuraLogo = 'https://i.postimg.cc/8c7fPWBn/ultimaker-Cura.png';


const Modelling3DView = () => {
  var contentWidth = (window.innerWidth)*(2/3);
  
  return (
    <div className='main-container-modelling'>
      <Container fluid={true}>
        <div className="main-block-top">
          <h1>3D Modelling</h1>
          <br/>
          <p>
            3D modelling is a strong passion of mine. I have experience in modelling, lighting, and rendering using Blender, with a portfolio 
            that includes personal, high school, and university projects. I'm eager to continually expand my skills in this field.
          </p>
        </div>



         <div className="main-block">
          <h2 className="modelling-header">Golden Hour</h2>
          
          <p className="modelling-p">
            A cinematic 3D render capturing the warm glow of golden hour over a suspension bridge surrounded by rolling forested hills. 
            The scene emphasizes natural lighting, volumetric atmosphere, and environmental storytelling to evoke a sense of scale and serenity.
          </p>

          <img src={bridge1} width={contentWidth} alt="Golden Hour"/>
        </div>


        
        <div className="main-block">
          <h2 className="modelling-header">Aftermath</h2>
          
          <p className="modelling-p">
            Original sports car concept, designed from scratch in Blender and inspired by the McLaren W1 and Lamborghini Temerario,
            brought to life within a 3D scene. 
          </p>

          <img src={car1} width={contentWidth} alt="Custom Sports Car"/>
        </div>



        <div className="main-block">
          <h2 className="modelling-header">Into the Mist</h2>
          
          <p className="modelling-p">
            A solitary journey across an endless suspension bridge disappearing into the mist.
            The visualization draws the viewer toward the horizon through strong leading lines and atmospheric depth. 
            Soft morning mist and warm lighting create a quiet, cinematic atmosphere while highlighting the bridge's monumental scale.
          </p>

          <img src={bridge2} width={contentWidth} alt="Into the Mist"/>
        </div>



        <div className="main-block">
          <h2 className="modelling-header">Relics</h2>
          
          <p className="modelling-p">
            A piece exploring modelling, material creation, lighting, and Blender plugins, rendered in Blender and refined in Photoshop.
          </p>

          <img src={lightsabers} width={contentWidth} alt="Lightsabers"/>
        </div>


        <div className="main-block">
          <h2 className="modelling-header">Solitude Beneath the Monolith</h2>
          
          <p className="modelling-p">
            A lone figure in red stands before immense geometric shadows, evoking mystery and scale.
          </p>
            <img src={columns} width={contentWidth} alt="Solitude Beneath the Monolith"/>
        </div>


        <div className="main-block">
          <h2 className="modelling-header">Sunset Apex</h2>
          
          <p className="modelling-p">
            A stylized 3D render of a modern Formula-1 car, made for a Sydney University visual design project. This focuses on stylized material creation, 
            dramatic framing and lighting, combining technical accuracy with a bold, illustrative visual style. Rendered in Blender and touched up in Affinity.
          </p>
            <img src={car3} width={contentWidth} alt="Sunset Apex"/>
        </div>


        <div className="main-block">
          <h2 className="modelling-header">Dystopian Hallway</h2>
          
          <p className="modelling-p">
            A study in atmosphere, visual focus, and dramatic lighting. 
          </p>

            <img src={hallway} width={contentWidth} alt="Dystopian Hallway"/>
        </div>


        <div className="main-block">
          <h2 className="modelling-header">Sci-fi Hallway</h2>
          {/* stick tags here */}

          <p className="modelling-p">
            Created to practice 3D modelling and lighting in Blender, with final touch-ups and refinements completed in Photoshop.
          </p>

          <ImgComparisonSlider hover={true}>
            <img slot="first" src={aztek1} width={contentWidth} alt="Aztek Robot Dark"/>
            <img slot="second" src={aztek2} width={contentWidth} alt="Aztek Robot Light"/>
          </ImgComparisonSlider>
        </div>


        <div className="main-block">
          <h2 className="modelling-header">Emergence</h2>
          
          <p className="modelling-p">
            A frame from my HSC Industrial Technology Multimedia major project—an original 3D animated short film, nominated for display at the SHAPE HSC Showcase.
          </p>

            <img src={bobaFett} width={contentWidth} alt="Boba Fett"/>
        </div>


        <div className="main-block">
          <h2 className="modelling-header">Japor Snippet</h2>
          
          <p className="modelling-p">
            A precise 3D replica of Anakin's Japor Snippet from Star Wars: Episode I - The Phantom Menace, sculpted from reference images 
            and textured using Blender's shader nodes and texture painting tools.
          </p>

            <img src={japorSnippet} width={contentWidth} alt="Japor Snippet"/>
        </div>


        {/* <div className="main-block">
          <h2 className="modelling-header">Sith Lightsaber</h2>
          
          <p className="modelling-p">
            A cinematic Sith lightsaber render, crafted in a vertical format for a striking, custom smartphone wallpaper.
          </p>

            <img src={lightsaber2} width={contentWidth/2.5} alt="Sith Lightsaber"/>
        </div> */}


        {/* <div className="main-block">
          <h2 className="modelling-header">Cad Bane</h2>
          
          <p className="modelling-p">
            A realistic 3D sculpt of Cad Bane from Star Wars, focused on capturing the character's distinctive features and personality. 
          </p>

            <img src={cadBane} width={contentWidth} alt="Cad Bane"/>
        </div> */}


        <Marquee
          pauseOnClick={true}
          autoFill={true}
          speed={40}
          gradient={true}
          gradientColor={themeManager.getCurrentColour()}
          gradientWidth={200}
          className='marqueeContainer'
        >
          <div className='sliderElement'>
            <img src={premierProLogo} alt="Premier Pro" className='w-36' />
          </div>
          <div className='sliderElement'>
            <img src={blenderLogo} alt="Blender" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={photoshopLogo} alt="Photoshop" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={onshapeLogo} alt="Onshape" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={zbrushLogo} alt="ZBrush" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={splineLogo} alt="Spline" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={simscaleLogo} alt="Simscale" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={prusaLogo} alt="Prusa" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={sketchupLogo} alt="Sketchup" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={unrealLogo} alt="Unreal Engine 5" className='w-36'/>
          </div>
          <div className='sliderElement'>
            <img src={ultimakerCuraLogo} alt="Ultimake Cura Slicer" className='w-36'/>
          </div>
        </Marquee>
        
      </Container>
    </div>
  );
};


class Modelling3dEntryPoints implements EntryPoints {
  renderFullView = (navItem: NavItem, secondaryNavItems: string[], width: number, height: number): any => {
    return <Modelling3DView />;
  }

  renderIntroView = (navItem: NavItem, secondaryNavItems: string[]): any => {
    return (
      <span>3D modelling intro</span>
    );
  }
}

const modelling3dEntryPoints = new Modelling3dEntryPoints();
export default modelling3dEntryPoints;